import * as React from 'react'
import { ICompany, IPayment } from '@getgreenline/homi-shared'
import { observer } from 'mobx-react'
import { LoyaltyModels } from '@getgreenline/loyalties'
import { ReceiptModels, ReceiptUtils } from '@getgreenline/receipts'
import QRCode from 'qrcode'

interface Props {
  company: ICompany
  payment: IPayment
  receiptSettings: ReceiptModels.IReceiptContract
  loyaltyData?: LoyaltyModels.ILoyaltyData
  loyaltyWalletUrl?: string
  paymentOptionNames?: { [key: number]: string }
  showPaidTag?: boolean
}

const populateQRCode = (loyaltyWalletUrl?: string) => {
  if (!loyaltyWalletUrl || loyaltyWalletUrl.length === 0) return

  try {
    QRCode.toCanvas(document.getElementById('qr-code'), loyaltyWalletUrl)
  } catch (error) {
    console.error('[QRCode ERROR]', error)
  }
}

@observer
export class ReceiptV3 extends React.Component<Props, {}> {
  componentDidMount(): void {
    populateQRCode(this.props.loyaltyWalletUrl)
  }

  componentDidUpdate(): void {
    populateQRCode(this.props.loyaltyWalletUrl)
  }

  render() {
    const {
      company,
      payment,
      loyaltyData,
      receiptSettings,
      loyaltyWalletUrl,
      paymentOptionNames,
      showPaidTag,
    } = this.props

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: ReceiptUtils.generateReceiptHTMLV3({
            company,
            payment,
            loyaltyData,
            receiptSettings,
            loyaltyWalletUrl,
            useExternalLibrary: true,
            paymentOptionNames,
            showPaidTag,
          }),
        }}
      />
    )
  }
}
